"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation generateUserService(
        $user: UserInput!
        $plannerType: String!
        $lotNumber: String
        $includeCorpCollections: Boolean!
        $includeRetailCollections: Boolean!
    ) {
        createUserAndPlanner(user: $user, plannerType: $plannerType, lotNumber: $lotNumber) {
            user {
                userId
                identityProviderUserId
                identityProviderId
                firstName
                lastName
                phone
                preferredContactMethod
                preferredContactTime
                preferredPronouns
                zipcode: zipCode
                retailCollections @include(if: $includeRetailCollections) {
                    nodes {
                        id: retailCollectionId
                        label
                        inventoryItems {
                            nodes {
                                id: retailCollectionInventoryItemId
                                collectionId: retailCollectionId
                                modelNumber
                                serialNumber
                            }
                        }
                    }
                }
                corpCollections @include(if: $includeCorpCollections) {
                    nodes {
                        id: corpCollectionId
                        label
                        collectionModels {
                            nodes {
                                id: corpCollectionModelId
                                collectionId: corpCollectionId
                                modelNumber
                            }
                        }
                    }
                }
            }
        }
    }
`;exports.generateUser=e;
//# sourceMappingURL=queries.js.map
